import React from 'react'

import AddDistrictForm from '../../modules/District/components/AddDistrictForm'
export default function AddDistrictPage() {
  return <AddDistrictForm />
}
